// serviceWorkerRegistration.js
export function register() {
    try {
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
          navigator.serviceWorker
            .register('/firebase-messaging-sw.js') // default location
            .then((registration) => {
              console.log('SW registered: ', registration);
            })
            .catch((registrationError) => {
              console.log('SW registration failed: ', registrationError);
            });
        });
      }
    } catch (error) {
      console.error('Error registering service worker:', error);
    }
  }
  